import * as React from "react";
import Authentication from "./pages/Authentication/Authentication";
import { createSignalRContext } from "react-signalr/signalr";
import { ChasablesProvider } from "./context/ChasablesContext";
import { PageContextProvider } from "./context/PageContext";
import { SuggestedChasableFiltersProvider } from "./pages/Chasables/SuggestedChasable/Filters/SuggestedChasableFiltersContext";
import { Auth0Provider } from "@auth0/auth0-react";
import { TokenContextProvider } from "./context/TokenContext";
import { ToastContextProvider } from "./context/ToastContext";
import { ReadingEmailProvider } from "./context/ReadingEmailContext";
import { TenantContextProvider } from "./context/TenantContextProvider";
import { SWRConfigProvider } from "./context/SWRConfigProvider";
import { environment } from "./config/environment";
import { useAppInsights } from "./services/appInsights";
import { Routes } from "./routes";
import { TelemetryEvents } from "./telemetry/eventNames";
import { TelemetryProp, toTelemetryProps } from "./telemetry/telemetryProps";
import { TelemetrySurface } from "./telemetry/surfaces";

interface AppProps {
  title: string;
}

export const NotificationSignalRContext = createSignalRContext();

const App: React.FC<AppProps> = () => {
  const { trackEvent } = useAppInsights();
  React.useEffect(() => {
    sessionStorage.setItem("initialLaunch", "true");
    trackEvent({
      name: TelemetryEvents.appLaunched,
      properties: toTelemetryProps({ [TelemetryProp.surface]: TelemetrySurface.app }),
    });
  }, [trackEvent]);

  return (
    <Auth0Provider
      domain={environment.auth.domain}
      clientId={environment.auth.clientId}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/taskpane.html`,
        audience: environment.auth.audience,
        scope: "openid profile email",
      }}
    >
      <ToastContextProvider>
        <TokenContextProvider>
          <Authentication>
            <TenantContextProvider>
              <SWRConfigProvider>
                <ChasablesProvider>
                  <SuggestedChasableFiltersProvider>
                    <PageContextProvider>
                      <ReadingEmailProvider>
                        <Routes />
                      </ReadingEmailProvider>
                    </PageContextProvider>
                  </SuggestedChasableFiltersProvider>
                </ChasablesProvider>
              </SWRConfigProvider>
            </TenantContextProvider>
          </Authentication>
        </TokenContextProvider>
      </ToastContextProvider>
    </Auth0Provider>
  );
};

export default App;
